import { render } from "./data_ipkd.vue?vue&type=template&id=5abac3a2"
import script from "./data_ipkd.vue?vue&type=script&lang=js"
export * from "./data_ipkd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__